const TF_SHIFT = 12;
const TOTFREQ = 1 << TF_SHIFT;
const RANS_BYTE_L = 1 << 23;
export { RANS_BYTE_L, TF_SHIFT, TOTFREQ };
//# sourceMappingURL=constants.js.map